import { TYPE_UNITEL_REVENUE, TYPE_VM_UNITEL } from "./type";

const initialState = {
  revenue: [],
};

export const reducerUnitel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_UNITEL_REVENUE:
      return {
        ...state,
        revenue: action.payload,
      };
    default:
      return state;
  }
};

export const reducerVmUnitel = (state = initialState, action) => {
  switch (action.type) {
    case TYPE_VM_UNITEL:
      return {
        ...state,
        data: action.payload,
      };
    default:
      return state;
  }
};
